import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

// Components
import Text from './Text'
import Link from './Link'

interface IProps {
  className?: string
  emptyText?: string
  clear?: {
    text: string
    clearFunc: () => void
  }
}

const EmptySearchState: React.FC<IProps> = ({
  className,
  emptyText,
  clear,
}) => {
  const { t } = useTranslation()
  return (
    <Wrapper className={className}>
      <Text
        textStyle="label"
        marginBottom={12}
        marginTop={12}
        textAlign="center"
      >
        {emptyText ? emptyText : t('general.forms.emptySearch')}
      </Text>
      {clear && (
        <Link
          caption={clear.text}
          color="primaryFadeHalf"
          hoverColor="primary"
          onClick={clear.clearFunc}
        />
      )}
    </Wrapper>
  )
}

export default EmptySearchState

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
